import { COOKIES_CONFIG, template } from '@belong/common';
import { Text } from '@belong/ui';
import clsx from 'clsx';
import { parseCookies } from 'nookies';
import { REFERRAL_MESSAGE_STRINGS } from '../referral-message/strings';
import css from './referral-banner.module.css';

const { REFERRAL_USER } = COOKIES_CONFIG;

export function ReferralBanner() {
  const cookies = parseCookies();
  const userName = cookies[REFERRAL_USER.name];

  // This flag '-1' is setted when the HO came from a referral link, but the referral user is no longer in Belong.
  // This cookie es needed every time a user uses a referral link, regardless of the response.
  if (!userName || userName === '-1') return null;

  return (
    <div className="h-3xl bg-dark-navy md:h-2xl flex items-center justify-center text-center">
      <Text fontWeight="semibold" className={clsx('text-white', css.text)}>
        {template(REFERRAL_MESSAGE_STRINGS['message.success-name'], {
          userName,
        })}{' '}
        <span className="text-green">
          {REFERRAL_MESSAGE_STRINGS['message.success-expedited']}
        </span>
      </Text>
    </div>
  );
}
